export default __webpack_public_path__ + "static/media/account.04c58093.png";